<template>
  <el-dialog :visible.sync="show" title="评价详情" center destroy-on-close @close="close">
    <el-form>
      <el-form-item label="分数">
        <div>{{ form.score }}</div>
      </el-form-item>
      <el-form-item label="内容">
        <div>{{ form.comment }}</div>
      </el-form-item>
      <el-form-item label="评价时间">
        <div>{{ form.created_at }}</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "commentDetail",
  data() {
    return {
      show: false,
      form: {
        score: 0,
        comment: '',
        created_at: ''
      }
    }
  },
  methods: {
    open(row) {
      this.form = row;
      this.show = true;
    },
    close() {
      this.show = false;
      this.$nextTick(() => {
        this.form = {
          score: 0,
          comment: '',
          created_at: ''
        };
      });
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// commentDetail.vue?7d62a87d